import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { WebParameterContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-potential-memberslist',
  templateUrl: './potential-memberslist.page.html',
  styleUrls: ['./potential-memberslist.page.scss'],
})

export class PotentialMemberslistPage implements OnInit {
  isCheck :number = 0;
  @Input() typeName: any;
  @Input() typeTitle: any;
  @Input() contentText: any;
  @Input() techniqueID: any; // 话术id
  @Input() currentId: any; // 话术id
  
  _type:any="";//判断类型
  communicationRecords:any; //信息反馈
  constructor(
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
  ) { }
  

  ngOnInit() {
    const that=this;
    that._type= that["type"];
    console.log(that._type,"类型类型")
    that._type=0;
    console.log(that.typeTitle)
    that.communicationRecords= that.contentText;
  }
  EventSelect(i){
    const that =this;
    that.isCheck = i;
    that._type=i;
  }
  // 编辑框
  RecordsInput(e){
    let that=this;
   if(e&&e.target.value){
    that.communicationRecords=e.target.value;
    //  if(e.target.value.length>120){
    //    e.target.value=e.target.value.substr(0,120);
    //    that.communicationRecords=e.target.value;
    //   }else{
    //    that.communicationRecords=e.target.value;
    //   }
    }
  }
  // 取消
  dismissModal() {
    const that=this;
    let _array:Array<any> = new Array<any>();
    this.modalController.dismiss({
      "modalStatus": false,
      "type":0,
      "info": '0',
      "typeTitle":that.typeTitle,
     
    });
  }
  // 确定
  comfireModal() {
    const that=this;
    that.modalController.dismiss({
      "modalStatus":true,
      "type":that._type,
      "info": "是的",
      "typeTitle":that.typeTitle,
    });
  }
  /**
   * 复制记录接口
   */
   duplicateRecords(){
    const that =this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "TBSendMessageRecordXML";
  body.OpType = "edite";
  body.ConfigType = "form";
  body.RowsPerPage = 15;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "product";
  body.Client.ClientType = 2;
  let typeObj = {};
  typeObj["a_ID"] =  that.currentId;
  typeObj["a_SendStatus"] =  "1";
  body.RequestBody = JSON.stringify(typeObj);
//  that.msg.Loading("加载中，请稍后...").then(load=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    // load.dismiss();
    if (data.ResponseMessage.Success) {
      
      
    }else{
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }

  }).catch(error => {
    // load.dismiss();
    that.msg.Alert(error.ResponseMessage.ErrorMessage);
    // console.log(error);
  });
  //  load.present();
//  })
  }
  // 复制
  dismissModalwx() {
    const that=this;
    let _array:Array<any> = new Array<any>();
//   const that=this;
  let text = "";
  if(that.communicationRecords){
    text=that.communicationRecords;
  }
  var aux = document.createElement("input"); 
  console.log(aux);
    aux.setAttribute("value", text); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    console.log(aux);
   console.log("打开微信"); 
   that.msg.Show("复制成功", "middle");
  try{
    that.duplicateRecords();
   }catch(err){

   }
    // this.modalController.dismiss({
    //   "modalStatus": false,
    //   "type":0,
    //   "info": '复制',
    //   "typeTitle":that.typeTitle,
     
    // });
  }
  // 发送
  comfireModalwx() {
    const that=this;
    that.modalController.dismiss({
      "modalStatus":true,
      "info": "发送",
      "typeTitle":that.typeTitle,
      "communicationRecords":that.communicationRecords
    });
  }
}
